var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 0H4C1.79086 0 0 1.79086 0 4V26C0 28.2091 1.79086 30 4 30H36C38.2091 30 40 28.2091 40 26V4C40 1.79086 38.2091 0 36 0ZM2 4C2 2.89543 2.89543 2 4 2H36C37.1046 2 38 2.89543 38 4V26C38 27.1046 37.1046 28 36 28H4C2.89543 28 2 27.1046 2 26V4ZM15 4C15 3.44772 15.4477 3 16 3H24C24.5523 3 25 3.44772 25 4C25 4.55228 24.5523 5 24 5H16C15.4477 5 15 4.55228 15 4ZM2 33C2 32.4477 2.44772 32 3 32H37C37.5523 32 38 32.4477 38 33C38 33.5523 37.5523 34 37 34H3C2.44772 34 2 33.5523 2 33Z",
    fill: "#50B247"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/Laptop.1864f7f1e226f906877521fd2ff9f39d.svg";
export { ForwardRef as ReactComponent };